import {
    EventClient,
    EventClientProvider,
    FormattedEvent,
} from '@eventbrite/event-renderer';
import classNames from 'classnames';
import React from 'react';
import { EventCard as ListingsEventCard } from '../EventCard/EventCard';

export const EventsList: React.FunctionComponent<{
    isAuthenticated: boolean;
    locale: string;
    affCode: string;
    title: string;
    events: Array<FormattedEvent>;
    forceTwoColumnLayout?: boolean;
}> = ({
    isAuthenticated,
    locale,
    affCode,
    title,
    events,
    forceTwoColumnLayout,
}) => {
    const eventClient = new EventClient();

    const expiredEventsGridClasses = classNames('expired-events-grid', {
        'expired-events-grid--flex-columns-2up': forceTwoColumnLayout,
    });

    return (
        <div className="expired-wrapper">
            <div className="container">
                <div>
                    <h2 className="related-events__heading">{title}</h2>
                </div>
                <ul className={expiredEventsGridClasses}>
                    <EventClientProvider client={eventClient}>
                        {events.map((event: FormattedEvent) => {
                            return (
                                <li
                                    key={event.id}
                                    className="expired-events-grid__item expired-events-grid__item--fixed-width"
                                >
                                    <ListingsEventCard
                                        event={event}
                                        isAuthenticated={isAuthenticated}
                                        affCode={affCode}
                                        statsigLocationString="Listings - All"
                                        isLazyImage={false}
                                        isRaised={false}
                                        locale={locale || 'en_US'}
                                    />
                                </li>
                            );
                        })}
                    </EventClientProvider>
                </ul>
            </div>
        </div>
    );
};
